/* 🤖 this file was generated by svg-to-ts */
export const matIconSportsGymnastics: {
  name: 'sports-gymnastics';
  data: string;
} = {
  name: 'sports-gymnastics',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M4 6c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2zM1 9h6l7-5 1.31 1.52-4.17 2.98H14L21.8 4 23 5.4 14.5 12 14 22h-2l-.5-10L8 11H1V9z"/></svg>`
};
